import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { USE_CLASSES } from './ButtonConstants';
import UIButton from './UIButton';
export default class UIFileButton extends Component {
  constructor(...args) {
    super(...args);
    this._file = null;

    this.handleClick = evt => {
      const {
        onClick
      } = this.props;
      if (this._file) this._file.click();
      if (onClick) onClick(evt);
    };
  }

  render() {
    const _this$props = this.props,
          {
      accept,
      Button,
      children,
      id,
      multiple,
      onChange
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["accept", "Button", "children", "id", "multiple", "onChange", "onClick"]);

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [Button && /*#__PURE__*/_jsx(Button, Object.assign({
        className: "private-file-button",
        "data-component-name": "UIFileButton",
        onClick: this.handleClick
      }, rest, {
        children: children
      })), /*#__PURE__*/_jsx("input", {
        className: "private-file-button__input hidden",
        id: id,
        ref: ref => this._file = ref,
        type: "file",
        accept: accept && accept.join(','),
        multiple: multiple,
        onChange: onChange
      })]
    });
  }

}
export const TestFileComponent = () => {
  return /*#__PURE__*/_jsx(UIFileButton, {
    accept: ['image/*'],
    use: "secondary"
  });
};
UIFileButton.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string.isRequired),
  Button: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  use: PropTypes.oneOf(Object.keys(USE_CLASSES))
};
UIFileButton.defaultProps = {
  accept: [],
  Button: UIButton,
  multiple: false,
  use: 'tertiary-light'
};
UIFileButton.displayName = 'UIFileButton';